import React, {Component} from "react";

export const AppContext = React.createContext();

export default class AppProvider extends Component {
  state = {
    proyectos: [
      
      
      {
        id:1,
        nombre: "Concurso Centro de Convenciones de Cafayate.",
        autores: "Arqs. Fabio Estremera – Andrés Francesconi – Ezequiel Spinelli.",
        ubicacion: "Ruta Nacional n° 40 esq. Río Loro Huasi, Cafayate, Salta.",
        descripcion: "El edificio retoma dos elementos característicos de la arquitectura tradicional de la región como lo son el patio y la galería, para reinterpretarlos como elementos activos dentro de la propuesta. En este esquema el Patio Principal se plantea como un hall al aire libre desde el cual es posible acceder al Foyer funcionando también como desborde del Salón de Usos Múltiples. En tanto la galería en los bordes Sur y Oeste del edificio, es repensada no solamente como un espacio de circulación sino como un espacio flexible capaz de albergar diversas funciones e integrarse espacial y funcionalmente al edificio, al tiempo que contiene y enmarca el paisaje. La imagen del edificio surge de la relación compositiva entre los volúmenes sólidos y las galerías, buscando simplicidad y claridad visual, en concordancia con el juego de llenos y vacíos de la arquitectura tradicional del noroeste.",
        programa: "Centro de convenciones, áreas exteriores.",
        año: "Concurso 2021. PRIMER PREMIO.",
        superficie: "5 hectárea. Construida: 2.500 m2.",
        colaboradores: "Giovannini Mario Pemintel Lines.",
        promotor: "Ministerio de Turismo y Deportes de la Provincia de Salta.",
      

        imagenes: [
          
          {
            nombre: "24-01-foto.jpg",
            id: 1
          },
          {
            nombre: "24-02-foto.jpg",
            id: 2
          },
          {
            nombre: "24-03-foto.jpg",
            id: 3
          },
          {
            nombre: "24-04-foto.jpg",
            id: 4
          },
          {
            nombre: "24-05-foto.jpg",
            id: 5
          },
          {
            nombre: "24-06-foto.jpg",
            id: 6
          },
          {
            nombre: "24-07-foto.jpg",
            id: 7
          },
          {
            nombre: "24-08-foto.jpg",
            id: 8
          },
          {
            nombre: "24-09-foto.jpg",
            id: 9
          },
          {
            nombre: "24-10-foto.jpg",
            id: 10
          },
          {
            nombre: "24-11-foto.jpg",
            id: 11
          },
          {
            nombre: "24-12-foto.jpg",
            id: 12
          },
          {
            nombre: "24-13-foto.jpg",
            id: 13
          },
          {
            nombre: "24-14-foto.jpg",
            id: 14
          },
          {
            nombre: "24-15-foto.jpg",
            id: 15
          },
          {
            nombre: "24-16-foto.jpg",
            id: 16
          }
        ]
      },


      
      
      
      
      {

        id:2,
        nombre: "Concurso Centro Administrativo Provincial Rawson.",
        autores: "Arqs. Ignacio Carón - Juliana Deschamps - Fabio Estremera - Andrés Francesconi - Javiera Gavernet.",
        ubicacion: "Ex zoológico provincial, Rawson, Chubut.",
        descripcion: "La estrategia radica en una pisada clara respecto de que todo espacio libre que no es tomado por la huella del edificio pertenece al ámbito del parque público. Perceptualmente, la configuración del edificio habla de un parque en relación al río. La conexión física y visual entre ambos es permanente, diversa y dinámica. Esta pauta alumbra las estrategias adoptadas para Parque-Edificio, donde se generen ámbitos diversos, y escalas de apertura articulados; en ese diálogo, el edificio ofrece soporte y apoyo para el parque y al mismo tiempo el parque atraviesa el edificio con naturalidad. El edificio se estructura en base a una pieza tipológica única, a dos crujías con un ritmo articulado potenciando su versatilidad. La pieza entera puede entenderse desde su lógica de corte transversal y el ritmado longitudinal que construyen la secuencia en plantas diáfanas con sistemas circulatorios y áreas de convivencia que configuran acentos y variaciones de una pieza que ameniza mediante relaciones cruzadas en vertical. El carácter tectónico se origina en la voluntad de construir una infraestructura, ambientalmente eficiente y constructivamente resistente al uso y al tiempo: piso y techo son dos planos de hormigón armado visto con sus instalaciones expuestas.",
        programa: "Parque, oficinas administrativas viviendas.",
        año: "Concurso 2021. SEGUNDO PREMIO",
        superficie: "20 hectárea. Construida: 33.600 m2.",
        colaboradores: "Ariana Castineyras, Maximiliano Cracco, Valeria Mattera, Giovannini Mario Pemintel Lines.",
        promotor: "Gobierno de la Provincia de Chubut.",
      

        imagenes: [
          
          {
            nombre: "23-01-foto.jpg",
            id: 1
          },
          {
            nombre: "23-02-foto.jpg",
            id: 2
          },
          {
            nombre: "23-03-foto.jpg",
            id: 3
          },
          {
            nombre: "23-04-foto.jpg",
            id: 4
          },
          {
            nombre: "23-05-foto.jpg",
            id: 5
          },
          {
            nombre: "23-06-foto.jpg",
            id: 6
          },
          {
            nombre: "23-07-foto.jpg",
            id: 7
          },
          {
            nombre: "23-08-foto.jpg",
            id: 8
          },
          {
            nombre: "23-09-foto.jpg",
            id: 9
          },
          {
            nombre: "23-10-foto.jpg",
            id: 10
          },
          {
            nombre: "23-11-foto.jpg",
            id: 11
          },
          {
            nombre: "23-12-foto.jpg",
            id: 12
          },
          {
            nombre: "23-13-foto.jpg",
            id: 13
          },
          {
            nombre: "23-14-foto.jpg",
            id: 14
          },
          {
            nombre: "23-15-foto.jpg",
            id: 15
          },
          {
            nombre: "23-16-foto.jpg",
            id: 16
          }
        ]
      },




      {
        id:3,
        nombre: "Espacio Cívico Ciudadano, Talca, Chile.",
        autores: "Arqs. Fabio Estremera – Javiera Gavernet – Julián Kelis – Ezequiel Spinelli.",
        ubicacion: "Ex Cárcel de Talca, Chile.",
        descripcion: "Concurso Internacional de Anteproyectos. Espacio Cívico Ciudadano, Talca, Chile. MENCIÓN HONROSA. La propuesta giró en torno a la reflexión sobre la manzana en el damero, su densificación, estratificación y superposición de usos y caracteres de los espacios configurados. El centro de atención, más que en la manzana en sí misma, se ubicó en su condición genérica, su valor sistémico, y garantizar una armoniosa articulación entre los diferentes usos y usuarios. La sistematización llevó a establecer elementos arquitectónicos tipo en cuanto a la capacidad, en cada uno de ellos, de construir espacios públicos legibles, identificables y con manifiesta vocación flexible y accesible. Se detectaron casos similares dentro del ejido de Talca ensayando instancias de diversa con estrategia que contemplan la convivencia con edificios históricos como argumento teórico que sustenta el proyecto.",
        programa: "Centro de convenciones, Centro Cultural, Oficinas Municipales, Oficinas Regionales, Oficinas de alquiler, Viviendas, Comercios, Estacionamientos.",
        año: "Concurso 2020-2021.",
        superficie: "1 hectárea. total, construida: 32.000 m2.",
        colaboradores: "Josefina Batiz, Antonella Bracco, Giovannini Mario Pemintel Lines, Joaquín Traverso.",
        promotor: "Municipalidad de Talca, Chile.",
      

        imagenes: [
          
          {
            nombre: "22-01-foto.jpg",
            id: 1
          },
          {
            nombre: "22-02-foto.jpg",
            id: 2
          },
          {
            nombre: "22-03-foto.jpg",
            id: 3
          },
          {
            nombre: "22-04-foto.jpg",
            id: 4
          },
          {
            nombre: "22-05-foto.jpg",
            id: 5
          },
          {
            nombre: "22-06-foto.jpg",
            id: 6
          },
          {
            nombre: "22-07-foto.jpg",
            id: 7
          },
          {
            nombre: "22-08-foto.jpg",
            id: 8
          },
          {
            nombre: "22-09-foto.jpg",
            id: 9
          },
          {
            nombre: "22-10-foto.jpg",
            id: 10
          }
        ]
      },






      {
        id:4,
        nombre: "Laboratorio GEN",
        autores: "Arqs. Juliana Deschamps- Fabio Estremera. DCV: Juan Corvalán.",
        ubicacion: "Calle 24 entre 60 y 61, La Plata, Provincia de Buenos Aires, Argentina.",
        descripcion: "La intervención se resume a conseguir, con recursos físicos y económicos mínimos y con un tiempo de ejecución abreviado, la mayor transformación posible y bajo un concepto renovado de lo que un laboratorio de análisis clínicos representa en el imaginario social. Era condición previa que la operación además debía ser absolutamente reversible una vez finalizado el contrato. Lo anterior redundó en una economía de operaciones con dos materiales (tubo de chapa pesado 20/20 y vidrio) más el uso de filtros vinílicos traslúcidos combinados cromáticamente. Escritorios, mesadas, divisiones, puertas, aleros, pantallas, están resueltos con una única sección que se coordina con planchuelas de apoyo para sostener el vidrio. Finalizado el contrato es posible remover y trasladar todos los componentes.",
        programa: "Adaptación transitoria de vivienda preexistente en Laboratorio de Análisis clínicos y biología molecular.",
        año: "2020. Proyecto y Obra.",
        superficie: "Terreno: 141 m2, total construida existente: 123 m2cubiertos. Construido: 0m2.",
        asesores: "Ing. Fabricio Barco, instalación Eléctrica y redes.",
        colaboradores: "Martin Bravi.",
        constructora: "Ramón Martínez.",
        fotografias: "Luis Barandiarán.",

        imagenes: [
          
          {
            nombre: "18-01-foto.jpg",
            id: 1
          },
          {
            nombre: "18-02-foto.jpg",
            id: 2
          },
          {
            nombre: "18-03-foto.jpg",
            id: 3
          },
          {
            nombre: "18-04-foto.jpg",
            id: 4
          },
          {
            nombre: "18-05-foto.jpg",
            id: 5
          },
          {
            nombre: "18-06-foto.jpg",
            id: 6
          },
          {
            nombre: "18-07-foto.jpg",
            id: 7
          },
          {
            nombre: "18-08-foto.jpg",
            id: 8
          },
          {
            nombre: "18-09-foto.jpg",
            id: 9
          },
          {
            nombre: "18-10-foto.jpg",
            id: 10
          },
          {
            nombre: "18-11-foto.jpg",
            id: 11
          },
          {
            nombre: "18-12-foto.jpg",
            id: 12
          }
        ]
      },


      {
        id:5,
        nombre: "Residencia de Adultos Mayores en Hospitalet de L’Infant.",
        autores: "Arqs.  Juliana Deschamps - Fabio Estremera – Javiera Gavernet – Walter Marchissio – Néstor Sulkin.",
        ubicacion: "Carrer Ramón Berenguer, Hospitalet de L’infant. Cataluña.",
        descripcion: "SEGUNDO PREMIO. El concurso se inscribe dentro de un área denominada la “la isla” donde se alojan las instituciones del pequeño pueblo costero de Hospitalet, a mitad de camino entre Barcelona y Valencia. La isla tiene un Plan de Reordenamiento Urbano donde un solar está destinado al edificio motivo del concurso. La estrategia tiene dos capas: la primera urbana dispone una pieza que formalmente reordene y clarifique el espacio que los bordes irregulares indefinidos del sector configuran en la actualidad. Al mismo tiempo, en la organización de los espacios y las actividades de planta baja, potencie las relaciones, continuidades y articulaciones con el espacio público inmediato y áreas de servicio y aparcamiento definidas en el PMUC. La segunda tiene que ver con organizar una planta tipo que ofrezca claridad, fomente sociabilidad, y brinde calidez a un usuario que, por su condición, requiere el máximo de atención sobre esos pilares de diseño.",
        programa: "Habitaciones, áreas de convivencia, espacios de servicio y áreas comunes de comedor y salas de estar.",
        año: "Concurso 2020.",
        superficie: "Terreno: 1800 m2. total, construida: 1.750 m2.",
        asesores: "Lic. Valentín Asprella, paisaje. Ing. Fabián Lafuente, estructuras.",
        colaboradores: "Leandro Cercato, Mie Tamashiro, Reiner Minaya.",
        promotor: "Insalut Catalunya.",
        
        imagenes: [
          
          {
            nombre: "19-01-foto.jpg",
            id: 1
          },
          {
            nombre: "19-02-foto.jpg",
            id: 2
          },
          {
            nombre: "19-03-foto.jpg",
            id: 3
          },
          {
            nombre: "19-04-foto.jpg",
            id: 4
          },
          {
            nombre: "19-05-foto.jpg",
            id: 5
          },
          {
            nombre: "19-06-foto.jpg",
            id: 6
          },
          {
            nombre: "19-07-foto.jpg",
            id: 7
          },
          {
            nombre: "19-08-foto.jpg",
            id: 8
          }
        ]
      },

      {
        id:6,
        nombre: "Parque de la ciudad Comodoro Rivadavia.",
        autores: "Arqs. Ignacio Caron, Juliana Deschamps - Fabio Estremera – Javiera Gavernet – Andrés Francesconi – Julián Kelis – Ezequiel Spinelli.",
        ubicacion: "Ruta Nacional n°3 esquina Antártida Argentina.",
        descripcion: "SEGUNDO PREMIO. El lugar imponía referencias pregnantes tanto de valor paisajístico como de infraestructuras portuario - petroleras, tan caras al Atlántico Sur Argentino y presentes en el entorno inmediato. Exponía además la complejidad topográfica que se sumaba un tejido mixto formado por industrias y viviendas unifamiliares de baja densidad. La rutan nacional 3 constituía el límite más preciso. Se propuso una pieza arquetípica de 200 mts. de longitud paralela a la ruta y de frente al Atlántico ubicada sobre la cota más alta. Una “estoa” que ordena y resignifica el sentido y la noción de paisaje abordando su complejidad. La pieza se presenta como un pivote para las diferentes escalas, situaciones y programas tanto exteriores, como así también el de la escuela de música la cual se coloca debajo de la “estoa” en contacto con la cota media del parque. La disposición de esta infraestructura establece la continuidad tanto con el tejido residencial, mediante una plaza cívica como con el Parque Huergo a través de un parque sonoro. Sobre la cota inferior se dispusieron las infraestructuras deportivas requeridas en contacto con el borde residencial.",
        programa: "Parque Urbano, Infraestructuras deportivas, Parque sonoro, ferias, Escuela de música popular.",
        año: "Concurso 2020.",
        superficie: "4 hectáreas. total, construida: 2100 m2.",
        asesores: "Lic. Gabriel Burgueño, Marina Giribaldi paisaje. Ing. Gustavo Basso, acústica.",
        colaboradores: "Martin Bravi, Leandro Cercato, Santiago Marelli, Ignacio Mazzucchelli, Giovannini Mario Pemintel Lines, Joaquín Traverso, Leandro Vogel.",
        promotor: "Municipalidad de Comodoro Rivadavia.",
        
        imagenes: [
          
          {
            nombre: "20-01-foto.jpg",
            id: 1
          },
          {
            nombre: "20-02-foto.jpg",
            id: 2
          },
          {
            nombre: "20-03-foto.jpg",
            id: 3
          },
          {
            nombre: "20-04-foto.jpg",
            id: 4
          },
          {
            nombre: "20-05-foto.jpg",
            id: 5
          },
          {
            nombre: "20-06-foto.jpg",
            id: 6
          },
          {
            nombre: "20-07-foto.jpg",
            id: 7
          },
          {
            nombre: "20-08-foto.jpg",
            id: 8
          },
          {
            nombre: "20-09-foto.jpg",
            id: 9
          },
          {
            nombre: "20-10-foto.jpg",
            id: 10
          },
          {
            nombre: "20-11-foto.jpg",
            id: 11
          },
          {
            nombre: "20-12-foto.jpg",
            id: 12
          },
          {
            nombre: "20-13-foto.jpg",
            id: 13
          },
          {
            nombre: "20-14-foto.jpg",
            id: 14
          },
          {
            nombre: "20-15-foto.jpg",
            id: 15
          },
          {
            nombre: "20-16-foto.jpg",
            id: 16
          }
        ]
      },

      {
        id:7,
        nombre: "Campus Educativo en Tigre",
        autores: "Arqs. Fabio Estremera – Javiera Gavernet – Ezequiel Spinelli– Mirella Villanueva Soto.",
        ubicacion: "Avenida Santa María de las Conchas y Canal Aliviador, Tigre, Provincia de Buenos Aires, Argentina.",
        descripcion: "Concurso Nacional de Ideas y Anteproyectos para el Complejo Educativo Tres Facultades y Campus Universitario. MENCION ESPECIAL - El concepto de ciudad, en su sentido primero, de comunidad constituye la base conceptual donde se origina la propuesta. Sobre esta idea proponemos una estructura que re signifique el concepto de campus para dar lugar al concepto de ciudad, donde: calles, manzanas, plazas y parques -lo compartido- configuren un ámbito de convivencia con las infraestructuras existentes y el paisaje circundante, aportando a una nueva identidad de carácter institucional. El tejido, definido por una trama regular de manzanas, procura establecerse como una referencia en la estructura urbana del sector apoyándose en el potencial del frente del canal aliviador y el puente. El equilibrio se construye maximizando el espacio libre, común; manteniendo la autonomía en los espacios para cada institución. La trama de espacios públicos (plazas, calles, y parques) adquiere claridad en la disposición reticular de los sólidos programáticos introduciendo variedad en los perfiles y profundidades; esto fomenta la orientación para los usuarios, y la identificación de cada sector y cada edificio. Dentro de esta lógica, la trama adquiere versatilidad en tres dimensiones con variaciones en las alturas, articulaciones y escalonados que transforman una retícula homogénea en una secuencia de espacios heterogéneos conectando dialécticamente con el paisaje, motivo por el cual el carácter no reniega de su condición artificial.",
        programa: "Jardín de Infantes, Escuela Primaria, Escuela Secundaria, Facultad de Arquitectura, Facultad de derecho y Facultad de Medicina, Aula Magna, Biblioteca, Residencia Universitaria, Estacionamientos cubiertos.",
        año: "Concurso 2020.",
        superficie: "Terreno: 39.000 m2. Total, construida: 32.600 m2.",
        asesores: "Lic. Valentín Asprella, paisaje. Ing. Fabián Lafuente, estructuras.",
        colaboradores: "Leandro Cercato, Santiago Marelli, Ignacio Mazzucchelli, Giovanni Mario Pemintel Lines, Joaquín Traverso.",
        promotor: "SALPE S.A.",
        organizador: "Colegio de Arquitectos de la Provincia de Buenos Aires",
        imagenes: [
          
          {
            nombre: "_00-00-foto.jpg",
            id: 1
          },
          {
            nombre: "_00-01-foto.jpg",
            id: 2
          },
          {
            nombre: "_00-02-foto.jpg",
            id: 3
          },
          {
            nombre: "_00-03-foto.jpg",
            id: 4
          },
          {
            nombre: "_00-04-foto.jpg",
            id: 5
          },
          {
            nombre: "_00-05-foto.jpg",
            id: 6
          },
          {
            nombre: "_00-06-foto.jpg",
            id: 7
          },
          {
            nombre: "_00-07-foto.jpg",
            id: 8
          },
          {
            nombre: "_00-08-foto.jpg",
            id: 9
          },
          {
            nombre: "_00-09-foto.jpg",
            id: 10
          },
          {
            nombre: "_00-10-foto.jpg",
            id: 11
          },
          {
            nombre: "_00-11-foto.jpg",
            id: 12
          },
          {
            nombre: "_00-12-foto.jpg",
            id: 13
          },
          {
            nombre: "_00-13-foto.jpg",
            id: 14
          },
          {
            nombre: "_00-14-foto.jpg",
            id: 15
          },
          {
            nombre: "_00-15-foto.jpg",
            id: 16
          },
          {
            nombre: "_00-16-foto.jpg",
            id: 17
          },
          {
            nombre: "_00-17-foto.jpg",
            id: 18
          },
          {
            nombre: "_00-18-foto.jpg",
            id: 19
          },
          {
            nombre: "_00-19-foto.jpg",
            id: 20
          },
          {
            nombre: "_00-20-foto.jpg",
            id: 21
          },
          {
            nombre: "_00-21-foto.jpg",
            id: 22
          },
          {
            nombre: "_00-22-foto.jpg",
            id: 23
          },
          {
            nombre: "_00-23-foto.jpg",
            id: 24
          },
          {
            nombre: "_00-24-foto.jpg",
            id: 25
          },
          {
            nombre: "_00-25-foto.jpg",
            id: 26
          },
          {
            nombre: "_00-26-foto.jpg",
            id: 27
          },
          {
            nombre: "_00-27-foto.jpg",
            id: 28
          },
         
          {
            nombre: "_00-28-foto.jpg",
            id: 29
          }
        ]
      },

      {
        id:8,
        nombre: "Casa y Estudio LS",
        autores: "Arqs. Juliana Deschamps- Fabio Estremera – Javiera Gavernet - Hernán Vázquez.",
        ubicacion: "Calle 18 entre 485 y arroyo Rodriguez, City Bell, La Plata, Provincia de Buenos Aires, Argentina.",
        descripcion: "El encargo requería adaptar el casco de una finca construida en los años '70 y transformarla en vivienda permanente para un usuario cuya actividad, a desarrollar en el mismo predio, implicaba recibir alumnos en la propiedad. La parcela es producto de la subdivisión de los 200m de longitud del predio con un único acceso sobre el lado corto de 30mts. y el contra-frente sobre el arroyo Rodríguez. Con ello se perdía la relación con el arroyo, transformándose en un predio entre medianeras cuya geometría tiende a un cuadrado donde la construcción existente sobre está próxima al borde medianero consolidado al norte. Las preexistencias se resumen en dos construcciones yuxtapuestas: una estructura masiva sin identidad tipológica y una estructura leve de perfiles de chapa y vidrio, conectada con el parque. Se optó por reordenar interviniendo mínimamente la primera para alojar allí el programa de la vivienda abriendo algunos huecos y cubriendo otros para iluminar mejor el interior; a la segunda se la restauró a la espera de los usos inesperados de una casa. La nueva construcción se destina al área de trabajo; la conexión a la preexistencia garantiza las relaciones con el espacio abierto de todas las estancias que define un ámbito exterior privado en relación al dormitorio permanente. Las decisiones espaciales y tectónicas del volumen a incorporar conectan con las estructuras preexistentes a través de referencias escalares, texturas, proporciones entre los cuerpos y los materiales utilizados, y la armonización cromática de los elementos. Define un ángulo permeable y etéreo en la nueva configuración del patio.",
        programa: "Residencia permanente para una persona, habitación de huéspedes y áreas comunes y exteriores. Sector de trabajo con ingreso independiente.",
        año: "2018-2019. Proyecto y Obra.",
        superficie: "Terreno: 582m2, Total, construida: 200 m2cubiertos (160 refacción + 40 obra nueva).",
        asesores: "Ing. Fabricio Barco, calculo estructural.",
        colaboradores: "Arqs. Natalia Larocca, Martin Bravi.",
        constructora: "Ramón Martinez.",
        fotografias: "Hernan Vazquez.",
        imagenes: [
          {
            nombre: "01-00-foto.jpg",
            id: 1
          },
          {
            nombre: "01-01-foto.jpg",
            id: 2
          },
          {
            nombre: "01-02-foto.jpg",
            id: 3
          },
          {
            nombre: "01-03-foto.jpg",
            id: 4
          },
          {
            nombre: "01-04-foto.jpg",
            id: 5
          },
          {
            nombre: "01-05-foto.jpg",
            id: 6
          },
          {
            nombre: "01-06-foto.jpg",
            id: 7
          },
          {
            nombre: "01-07-foto.jpg",
            id: 8
          },
          {
            nombre: "01-08-foto.jpg",
            id: 9
          },
          {
            nombre: "01-09-foto.jpg",
            id: 10
          },
          {
            nombre: "01-10-foto.jpg",
            id: 11
          },
          {
            nombre: "01-11-foto.jpg",
            id: 12
          },
          {
            nombre: "01-12-foto.jpg",
            id: 13
          },
          {
            nombre: "01-13-foto.jpg",
            id: 14
          },
          {
            nombre: "01-14-foto.jpg",
            id: 15
          },
          {
            nombre: "01-15-foto.jpg",
            id: 16
          },
          {
            nombre: "01-16-foto.jpg",
            id: 17
          },
          {
            nombre: "01-17-foto.jpg",
            id: 18
          },
          {
            nombre: "01-18-foto.jpg",
            id: 19
          },
          {
            nombre: "01-19-foto.jpg",
            id: 20
          },
          {
            nombre: "01-20-foto.jpg",
            id: 21
          },
          {
            nombre: "01-plano-01-foto.jpg",
            id: 22
          },
          {
            nombre: "01-plano-01a-foto.jpg",
            id: 23
          },
          {
            nombre: "01-plano-02-foto.jpg",
            id: 24
          },
          {
            nombre: "01-plano-03-foto.jpg",
            id: 25
          },
          {
            nombre: "01-plano-04-foto.jpg",
            id: 26
          },
          {
            nombre: "01-plano-05-foto.jpg",
            id: 27
          },
          {
            nombre: "01-plano-06-foto.jpg",
            id: 28
          },
         
          {
            nombre: "01-plano-07-foto.jpg",
            id: 29
          }
        ]
      },



      {
        id:9,
        nombre: "Archivo Nacional de Cataluña",
        autores: "Arqs. Juliana Deschamps- Fabio Estremera – Javiera Gavernet – Walter Marchissio – Néstor Sulkin – Hernán Vazquez.",
        ubicacion: "Sant Cugat del Vallés, Cataluña. España.",
        descripcion: "Concurso a dos vueltas Para la Ampliación del Archivo Nacional de Cataluña. SEGUNDO PREMIO - Nuestra propuesta de ampliación del Archivo Nacional de Cataluña integra un zócalo sobre la carretera de Vallvidrera al edificio existente. En los alzados del equipamiento se constata el equilibrio entre las diferentes piezas de la intervención contraponiendo la intervención con el carácter puntual de la pre-existencia. Este zócalo opera dos escalas: define una escala de cercanía amortiguando la relación con un entorno residencial de baja densidad; y se presenta como contrapunto a escala paisajística con el parque como elemento urbano de referencia. En su interior, se potencia un patio longitudinal central que opera como filtro entre el edificio ANC y la ampliación. Éste tiene funciones específicas: iluminar, ventilar y conectar los recorridos de ambos edificios, generando un ambiente amable, iluminado y ventilado naturalmente para el usuario protegido del exterior.",
        programa: "Areas de recepción, áreas técnicas y ampliación de depósito de documentos.",
        año: "Primera vuelta: marzo 2018, Segunda vuelta: octubre 2018.",
        superficie: "Terreno: 1923 m2. Total, construida: 3210 m2.",
        promotor: "Departament de Cultura de la Generalitat de Catalunya.",
        colaboradores: "Emilia Fernandez, Mie Tamashiro, Rainer Minaya.",
       
        imagenes: [
          {
            nombre: "02-00-foto.jpg",
            id: 1
          },
          {
            nombre: "02-01-foto.jpg",
            id: 2
          },
          {
            nombre: "02-02-foto.jpg",
            id: 3
          },
          {
            nombre: "02-03-foto.jpg",
            id: 4
          },
          {
            nombre: "02-04-foto.jpg",
            id: 5
          },
          {
            nombre: "02-05-foto.jpg",
            id: 6
          },
          {
            nombre: "02-06-foto.jpg",
            id: 7
          },
          {
            nombre: "02-07-foto.jpg",
            id: 8
          },
          {
            nombre: "02-08-foto.jpg",
            id: 9
          },
          {
            nombre: "02-09-foto.jpg",
            id: 10
          },
          {
            nombre: "02-10-foto.jpg",
            id: 11
          },
          {
            nombre: "02-11-foto.jpg",
            id: 12
          },
          {
            nombre: "02-12-foto.jpg",
            id: 13
          },
          {
            nombre: "02-13-foto.jpg",
            id: 14
          },
          {
            nombre: "02-14-foto.jpg",
            id: 15
          },
          {
            nombre: "02-15-foto.jpg",
            id: 16
          },
          {
            nombre: "02-16-foto.jpg",
            id: 17
          },
          {
            nombre: "02-17-foto.jpg",
            id: 18
          }
        ]
      },





      {
        id:10,
        nombre: "Casa EB",
        autores: "Arqs. Juliana Deschamps - Fabio Estremera.",
        ubicacion: "Calle 507 entre 132 y 132 bis, Barrio Don Carlos, La Plata, Provincia de Buenos Aires, Argentina.",
        descripcion: 'La casa reinterpreta requisitos muy claros de parte del usuario respecto de habitar en una casa "de campo, abierta y con galería (sic)". La cuidada elección del lote en un tejido abierto cuya normativa garantiza la concreción de esos intereses, facilitó la configuración de una vivienda en planta baja en contacto con el suelo, liberada de los cuatro bordes. La posición de la casa respecto del eje longitudinal del lote lo establece la ubicación de los linderos y las restricciones de fondo en los terrenos libres. El centro geométrico lo referencia el estar - comedor con la galería que definen hacia atrás un parque cuadrado que se vuelve exponencial asociado a los vacíos de los linderos y con la pileta cruzada en el ancho próxima al fondo. Esta primera decisión de proyecto llevó al planteo general escondiendo la zona privada que se abre de espaldas al espacio público de la casa, hacia el borde con sol matinal  y cuyo muro divisorio acompaña, entre el piso y el techo, la secuencia articulada entre jardín - semicubierto - patio, la llegada al área social. Dos planos coincidentes - piso y techo - definen la relación espacial de la vivienda con el suelo. Ambos elementos del mismo espesor dan lugar a todas las estancias incluyendo el patio que articula el ingreso. Los hábitos del usuario plantearon la necesidad de cerrar la casa por completo requisito que incorporó un elemento de diseño que fue utilizado para definir ámbitos intermedio habitables aún estando cerrada.',
        programa: "Residencia permanente para una persona; habitación de huéspedes, sector de trabajo; áreas exteriores y piscina.",
        año: "2016-2017. Proyecto y Obra.",
        superficie: "Terreno: 752,5m2, Total, construida: 123m2 cubiertos + 87m2 semicubiertos.",
        asesores: "Ing. Fabricio Barco, cálculo estructural.",
        colaboradores: "Arqs. Natalia Larocca, Martin Bravi.",
        constructora: "David Añazgo.",
        fotografias: "DEarquitectura + Ezequiel Spinelli.",
        
        imagenes: [
          {
            nombre: "03-00-foto.jpg",
            id: 1
          },
          {
            nombre: "03-01-foto.jpg",
            id: 2
          },
          {
            nombre: "03-02-foto.jpg",
            id: 3
          },
          {
            nombre: "03-03-foto.jpg",
            id: 4
          },
          {
            nombre: "03-04-foto.jpg",
            id: 5
          },
          {
            nombre: "03-05-foto.jpg",
            id: 6
          },
          {
            nombre: "03-06-foto.jpg",
            id: 7
          },
          {
            nombre: "03-07-foto.jpg",
            id: 8
          },
          {
            nombre: "03-08-foto.jpg",
            id: 9
          },
          {
            nombre: "03-09-foto.jpg",
            id: 10
          },
          {
            nombre: "03-10-foto.jpg",
            id: 11
          },
          
         
          {
            nombre: "03-plano-00-foto.jpg",
            id: 12
          },
          {
            nombre: "03-plano-01-foto.jpg",
            id: 13
          },
          {
            nombre: "03-plano-02-foto.jpg",
            id: 14
          },
          {
            nombre: "03-plano-03-foto.jpg",
            id: 15
          },
          {
            nombre: "03-plano-04-foto.jpg",
            id: 16
          },
          {
            nombre: "03-plano-05-foto.jpg",
            id: 17
          },
          {
            nombre: "03-plano-06-foto.jpg",
            id: 18
          },
          {
            nombre: "03-plano-07-foto.jpg",
            id: 19
          }
         
        ]
      },


      {
        id:11,
        nombre: "Sede Archivo General de la Nación Argentina",
        autores: "Arqs.  Juliana Deschamps- Fabio Estremera – Javiera Gavernet.",
        ubicacion: "Calles Pinchincha, Rondeau, Pasco, 15 de noviembre de 1889. Ciudad Autónoma de Buenos Aires, Argentina.",
        descripcion: 'La obra presentaba, a grandes rasgos, dos fuertes condicionantes en cuanto al lugar y al tema. La primera exhibía por una parte los efectos del abandono de infraestructuras urbanas, y por otro exponía la singularidad de un tejido heterogéneo compuesto por largos y "mudos" muros; grandes infraestructuras como el Hospital Garraham, el viejo edificio de la cárcel, edificios terciarios de logística y almacenamiento y áreas verdes de gran escala; continuidades ambientales del espacio público como el túnel de tipas añejas de calle Pichincha, y algunos pequeños edificios sobre lotes de dimensión habitual intercalados y consolidando, siempre, líneas municipales. El programa presentaba como principal desafío un edificio con mucha superficie, pocos usuarios, y escaso uso público; la mayor porción de superficie iba destinada al almacenamiento de documentos (papeles, fotos, videos, audios), y un crecimiento que cuadriplicaba la superficie inicial destinada a alojar más documentos. La estrategia general sintetiza las variables enunciadas y dispone las áreas activadas con público en la planta baja de manera que revitalice el espacio público. Ofrece, sin intermediarios, las pautas para una reconstrucción escalar y de uso, para y con el sitio. Conecta con esta condición la voluntad de definir, en la etapa inicial, el carácter del espacio público identificado como prioritario La plaza sobre la apertura de la calle Rondeau y el ensanche de vereda conformando una plaza lineal sobre Pichincha sin que esta caracterización se viera alterada en las etapas futuras.',
        programa: "Áreas públicas: Sala de usos múltiples, sala de exhibición, y cafetería. Áreas con control de acceso público: Sala de consulta, Sala de lectura. Áreas Administrativas: Oficinas administrativas, oficinas, jerárquicas, aulas, archivos. Áreas técnicas restringida: recepción de material, digitalización, restauración, limpieza de documentos, catalogación. Áreas de depósito restringido: archivo de documentos.",
        año: "Concurso 2012. Proyecto 2014. Obra 2016-2019.",
        superficie: "Terreno: 7700 m2. Total, construida: 10.516m2.",
        asesores: "Ing. H. Chevez, cálculo estructural., Arq. H. Bersanker: cómputo y presupuesto. GNBA Consultora: instalaciones. Estudio Angeli: Cerramientos exteriores. Ing. E. Mendiguren: geotécnica. Estudio Tonello – Pintus: Paisajismo. Arq. G. Nicolea: Fachadas ventiladas",
        colaboradores: "Arq. N. Larocca, F. Di Bin, F. Angelleri, (pliego) M. L. Carminatti (ajuste de anteproyecto), M. Bravi (dibujos para publicación).",
        constructora: "RIVA S.A.",
        fotografias: "H. Vázquez, estudioDEarquitectura.",
        
        imagenes: [
          
          {
            nombre: "04-00-foto.jpg",
            id: 1
          },
          {
            nombre: "04-01-01-foto.jpg",
            id: 2
          },
          {
            nombre: "04-01-02-foto.jpg",
            id: 3
          },
          {
            nombre: "04-01-03-foto.jpg",
            id: 4
          },
          {
            nombre: "04-01-04-foto.jpg",
            id: 5
          },
          {
            nombre: "04-01-05-foto.jpg",
            id: 6
          },
          {
            nombre: "04-01-06-foto.jpg",
            id: 7
          },
          {
            nombre: "04-01-07-foto.jpg",
            id: 8
          },
          {
            nombre: "04-01-08-foto.jpg",
            id: 9
          },
          {
            nombre: "04-01-09-foto.jpg",
            id: 10
          },
          {
            nombre: "04-01-10-foto.jpg",
            id: 11
          },
          {
            nombre: "04-02-foto.jpg",
            id: 12
          },
          {
            nombre: "04-03-foto.jpg",
            id: 13
          },
          {
            nombre: "04-04-foto.jpg",
            id: 14
          },
          {
            nombre: "04-05-foto.jpg",
            id: 15
          },
          {
            nombre: "04-06-foto.jpg",
            id: 16
          },
          {
            nombre: "04-07-foto.jpg",
            id: 17
          },
          {
            nombre: "04-08-foto.jpg",
            id: 18
          },
          {
            nombre: "04-09-foto.jpg",
            id: 19
          },
          {
            nombre: "04-10-foto.jpg",
            id: 20
          },
          {
            nombre: "04-11-foto.jpg",
            id: 21
          },
          {
            nombre: "04-12-foto.jpg",
            id: 22
          },
          {
            nombre: "04-13-foto.jpg",
            id: 23
          },
          {
            nombre: "04-14-foto.jpg",
            id: 24
          },
          {
            nombre: "04-15-foto.jpg",
            id: 25
          },
          {
            nombre: "04-16-foto.jpg",
            id: 26
          },
          {
            nombre: "04-17-foto.jpg",
            id: 27
          },
          {
            nombre: "04-18-foto.jpg",
            id: 28
          },
          {
            nombre: "04-19-foto.jpg",
            id: 29
          },
          {
            nombre: "04-20-foto.jpg",
            id: 30
          },
          {
            nombre: "04-21-foto.jpg",
            id: 31
          },
          {
            nombre: "04-22-foto.jpg",
            id: 32
          },
          {
            nombre: "04-23-foto.jpg",
            id: 33
          }
         
        ]
      },


      {
        id:12,
        nombre: "Sede Social y Cultural del Distrito de Sant Martí",
        autores: "Arqs.  Juliana Deschamps- Fabio Estremera – Javiera Gavernet – Walter Marchissio – Néstor Sulkin - Mirella Villanueva Soto.",
        ubicacion: "Carrer Alfons el Magnanim, Sant Martí, Barcelona,  Cataluña. España.",
        descripcion: "Concurso a una vuelta Para la Sede Social y Cultural del Distrito de Sant Martí. SEGUNDO PREMIO - La propuesta da respuesta al objeto de la actuación y a su singularidad programática: ello se resuelve mediante un exhaustivo estudio del programa y de sus relaciones, prestando máxima atención a la posibilidad de uso en diferentes franjas horarias o en la simultaneidad sin entorpecer las relaciones internas. La planta baja se propone como una calle pasante con función (salas de espera), cualificando este espacio como parte del programa y garantizando el dinamismo que sugiere el programa, permitiendo el acceso al auditorio ubicado bajo rasante. En la planta primera se disponen las áreas sociales, prestando máxima atención al uso y singularidad de la sala de estudios nocturnos (mediante su sección y ubicación), la cual actuará como un faro de luz sobre la ciudad. En las plantas segunda y tercera se organizan los servicios previstos en el programa, obteniendo una máxima flexibilidad en el momento de escoger su distribución. A su vez, la organización escogida permite conseguir la doble altura de la sala de estudios y la máxima superficie de planta en la cubierta cívica.",
        programa: "Oficinas de atención al público, Oficinas administrativas, Áreas públicas: Sala de estudios - biblioteca y Microcine, Sala de Usos Múltiples.",
        año: "Concurso 2017.",
        superficie: "Terreno: 825 m2. Total, construida: 4160 m2.",
        colaboradores: "Arq. Juan Ignacio Derrasaga, Emilia Fernandez, Mie Tamashiro, Rainer Minaya.",
        promotor: "BIMSA.",
        
        imagenes: [
          {
            nombre: "05-00-foto.jpg",
            id: 1
          },
          {
            nombre: "05-01-foto.jpg",
            id: 2
          },
          {
            nombre: "05-02-foto.jpg",
            id: 3
          },
          {
            nombre: "05-03-foto.jpg",
            id: 4
          },
          {
            nombre: "05-04-foto.jpg",
            id: 5
          },
          {
            nombre: "05-05-foto.jpg",
            id: 6
          },
          {
            nombre: "05-06-foto.jpg",
            id: 7
          },
          {
            nombre: "05-07-foto.jpg",
            id: 8
          },
          {
            nombre: "05-08-foto.jpg",
            id: 9
          },
          {
            nombre: "05-09-foto.jpg",
            id: 10
          },
          {
            nombre: "05-10-foto.jpg",
            id: 11
          },
          {
            nombre: "05-11-foto.jpg",
            id: 12
          },
          {
            nombre: "05-12-foto.jpg",
            id: 13
          },
          {
            nombre: "05-13-foto.jpg",
            id: 14
          },
          {
            nombre: "05-14-foto.jpg",
            id: 15
          },
          {
            nombre: "05-15-foto.jpg",
            id: 16
          },
          {
            nombre: "05-16-foto.jpg",
            id: 17
          }
         
        ]
      },




      {
        id:13,
        nombre: "Anexo del Ministerio de Economía",
        autores: "Arqs.  Juliana Deschamps- Fabio Estremera – Javiera Gavernet – Hernán Vazquez – Mirella Villanueva Soto.",
        ubicacion: "Calle 45 entre 6 y 7. La Plata. Provincia de Buenos Aires, Argentina.",
        descripcion: "Concurso Provincial para el Anexo del Ministerio de Economía de la Provincia de Buenos Aires. MENCION HONORÍFICA - El concurso requería un edificio para alojar dependencias administrativas del Ministerio ubicado en la manzana de enfrente al predio. El solar poseía una condicionantes particulares: de proporción cuadrada y frente único tenía por lindero el edificio “El Comerio” de Sanchez Lagos y De la Torre; un edificio que, ubicado en la esquina, reconstruye la línea hasta los 7m de altura para luego soltarse de los bordes hasta su remate. Nos propusimos indagar en estas condicionantes con nuestro edificio como articulador entre el tejido anónimo y el edificio de El Comercio, potenciando las oportunidades que este dejaba con su retiro y la fachada lateral con vistas diagonales hacia Avenida 7. La posición del núcleo vertical de servicios y circulaciones liberaba las plantas de uso para oficinas garantizando dos y hasta tres caras de perímetro libre. La respuesta formal de la envolvente intenta evitar los reflejos de un contexto fragmentario y establecer un diálogo desde la distancia con el edificio El Comercio; persigue una neutralidad silenciosa que no evada la afirmación de su presencia, y realce la expresión tectónica de su vecino sin distorsión.",
        programa: "Oficinas administrativas, Áreas públicas: Biblioteca y Usos múltiples. Estacionamientos cubiertos.",
        año: "Concurso 2015.",
        asesores: "Ing. Fabricio Barco, estructuras.",
        superficie: "Terreno: 730 m2. Total, construida: 4670 m2.",
        colaboradores: "Arq. Juan Ignacio Derrasaga, Juan Martín Scinardo, Pablo Torres.",
        promotor: "Ministerio de Economía de la Provincia de Buenos Aires.",
        organizador: "Colegio de Arquitectos de la Provincia de Buenos Aires.",
        
        imagenes: [
          {
            nombre: "08-00-foto.jpg",
            id: 1
          },
          {
            nombre: "08-01-foto.jpg",
            id: 2
          },
          {
            nombre: "08-02-foto.jpg",
            id: 3
          },
          {
            nombre: "08-03-foto.jpg",
            id: 4
          },
          {
            nombre: "08-04-foto.jpg",
            id: 5
          },
          {
            nombre: "08-05-foto.jpg",
            id: 6
          },
          {
            nombre: "08-06-foto.jpg",
            id: 7
          },
          {
            nombre: "08-07-foto.jpg",
            id: 8
          },
          {
            nombre: "08-08-foto.jpg",
            id: 9
          },
          {
            nombre: "08-09-foto.jpg",
            id: 10
          },
          {
            nombre: "08-10-foto.jpg",
            id: 11
          }
         
        ]
      },




      {
        id:14,
        nombre: "Casa DDM",
        autores: "Arqs. Juliana Deschamps - Fabio Estremera.",
        ubicacion: "Calle 459 Entre 10 Y 11 - Barrio El Quimilar - City Bell, La Plata, Provincia de Buenos Aires, Argentina.",
        descripcion: "La especulación en el uso del suelo produce extrañas hibridaciones en el carácter del espacio público. Este es caso donde, sobre una zonificación de tejido abierto, se subdividen parcelas generando lotes de 10m de ancho con contactos por una medianera que, al estar desregulados producen situaciones poco colaborativas en la construcción del espacio público. De esta primera reflexión y de las proporciones del lote 1:5 deriva la estrategia por la cual, sobre una métrica de 4x4 m. y estructurados sobre dos crujías, las estancias de la casa suceden estableciendo una secuencia de luces y sombras, vacíos, plantas, terrazas, semicubiertos y espacios a doble altura. Mientras la planta baja discurre así, sobre los 50 metros de longitud; la planta alta articula las estancias entre terrazas, vacíos cubiertos y descubiertos que delimita y establece los ámbitos de privacidad necesaria para cada integrante. Lo anterior posibilita la llegada de la casa a la línea de frente de manera articulada entre las dos crujías, evitando el contacto con los linderos con un ritmo lleno-vacío de 4-4-4 (vacío - lleno - vacío); y reestablece el ambiente de un tejido de frentes ajardinados no-consolidados. La métrica define la estructura portante y las relaciones entre opacidades y transparencias del cerramiento. El cuerpo tectónico de la obra se apoya en intereses del usuario por el hormigón visto el cual actúa como plano horizontal para toda la casa lo que produjo también la inversión en la secuencia constructiva del entrepiso. Para la cubierta se toma la misma estrategia.",
        programa: "Residencia permanente unifamiliar en dos niveles; con tres dormitorios, áreas comunes sectorizadas, áreas exteriores y piscina.",
        año: "2015-2016. Proyecto y Obra.", 
        superficie: "Terreno: 500 m2, Total construida: 190 cubierta+ 45 m2 semicubierta, + piscina.",
        asesores: "Ing. Juan Rojas, calculo estructural.",
        colaboradores: "Documentación: Arqs. Javiera Gavernet; Dibujos: Martin Bravi.",
        constructora: "Hormigón Armado: Claudio Pereira + Albañileria e instalaciones: David Añazgo.",
        fotografias:"Luis Barandiaran.",

        imagenes: [
          {
            nombre: "09-00-foto.jpg",
            id: 1
          },
          {
            nombre: "09-01-foto.jpg",
            id: 2
          },
          {
            nombre: "09-02-foto.jpg",
            id: 3
          },
          {
            nombre: "09-03-foto.jpg",
            id: 4
          },
          {
            nombre: "09-04-foto.jpg",
            id: 5
          },
          {
            nombre: "09-05-foto.jpg",
            id: 6
          },
          {
            nombre: "09-06-foto.jpg",
            id: 7
          },
          {
            nombre: "09-07-foto.jpg",
            id: 8
          },
          {
            nombre: "09-08-foto.jpg",
            id: 9
          },
          {
            nombre: "09-09-foto.jpg",
            id: 10
          },
          {
            nombre: "09-10-foto.jpg",
            id: 11
          },
          
         
          {
            nombre: "09-plano-00-foto.jpg",
            id: 12
          },
          {
            nombre: "09-plano-01-foto.jpg",
            id: 13
          },
          {
            nombre: "09-plano-03-foto.jpg",
            id: 14
          },
          {
            nombre: "09-plano-04-foto.jpg",
            id: 15
          },
          {
            nombre: "09-plano-05-foto.jpg",
            id: 16
          },
          {
            nombre: "09-plano-06-foto.jpg",
            id: 17
          },
          {
            nombre: "09-plano-07-foto.jpg",
            id: 18
          },
          {
            nombre: "09-plano-08-foto.jpg",
            id: 19
          },       
          {
            nombre: "09-plano-10-foto.jpg",
            id: 20
          }
        ]
      },



      {
        id:15,
        nombre: "Casa YP",
        autores: "Arqs.  Juliana Deschamps - Fabio Estremera - Elisa Deschamps.",
        ubicacion: "Calle 16 entre 494 y 493 bis, Barrio Gonnet,La Plata,Provincia de Buenos Aires, Argentina.",
        descripcion: "El encargo requería definir ámbitos domésticos para un usuario permanente, aunque con habitantes temporarios de permanencia indefinida, y con diferente grado de relación y parentesco; esto marcó la estrategia inicial de una casa en planta baja (área social, baños, y habitación principal), con dos dependencias independientes en planta alta (cuartos completos con baño y terraza). El lugar común de confluencia se da en la crujía más próxima al fondo del lote configurando una unidad espacial entre: lugar cubierto, jardín y piscina. Nuestro accionar en la materialización de la obra llegaba hasta completar una estructura con cierto grado de acabado en algunos sectores, pero abierta a la acción del residente permanente en muchos otros. La casa se iría configurando en el tiempo. Espacialmente, el lote de 275m2 entre medianeras, se estructura a lo largo en una secuencia de tres partes articuladas por patios, mientras que en el ancho se regula en tercios que alternan direccionalidades y relaciones de proporción. La casa en planta baja se camina completa haciendo de las estancias ámbitos fluidos y compartidos; con una paleta material reducida, esas estancias toman distinto carácter debido a las proporciones, la incidencia de la luz y el grado de apertura y relación entre los mismos. Esta percepción dinámica se combina con las terrazas de planta alta que participan en todo momento de la secuencia descripta construyendo una unidad espacial articulada secuencialmente.",
        programa: "Residencia permanente para una persona; 2 habitaciones de huéspedes con servicio privado, áreas exteriores y piscina.",
        año: "2012-2013. Proyecto y Obra.", 
        superficie: "Terreno: 285 m2; total construida: 112m2 cubiertos + 24 m2 semicubiertos",
        asesores: "Ing. Fabricio Barco, calculo estructural.",
        colaboradores: "Arq. María Laura Carminatti.",
        constructora: "Ariel Burgos.",
        fotografias:"Luis Barandiaran.",

        imagenes: [
          {
            nombre: "21-01-foto.jpg",
            id: 1
          },
          {
            nombre: "21-02-foto.jpg",
            id: 2
          },
          {
            nombre: "21-03-foto.jpg",
            id: 3
          },
          {
            nombre: "21-04-foto.jpg",
            id: 4
          },
          {
            nombre: "21-05-foto.jpg",
            id: 5
          },
          {
            nombre: "21-06-foto.jpg",
            id: 6
          },
          {
            nombre: "21-07-foto.jpg",
            id: 7
          },
          {
            nombre: "21-08-foto.jpg",
            id: 8
          },
          {
            nombre: "21-09-foto.jpg",
            id: 9
          },
          {
            nombre: "21-10-foto.jpg",
            id: 10
          },
          {
            nombre: "21-11-foto.jpg",
            id: 11
          },
          
         
          {
            nombre: "21-12-foto.jpg",
            id: 12
          },
          {
            nombre: "21-13-foto.jpg",
            id: 13
          },
          {
            nombre: "21-14-foto.jpg",
            id: 14
          },
          {
            nombre: "21-15-foto.jpg",
            id: 15
          },
          {
            nombre: "21-16-foto.jpg",
            id: 16
          },
          {
            nombre: "21-17-foto.jpg",
            id: 17
          },
          {
            nombre: "21-18-foto.jpg",
            id: 18
          },
          {
            nombre: "21-19-foto.jpg",
            id: 19
          },       
          {
            nombre: "21-20-foto.jpg",
            id: 20
          },
          {
            nombre: "21-21-foto.jpg",
            id: 21
          },
          {
            nombre: "21-22-foto.jpg",
            id: 22
          },
          {
            nombre: "21-23-foto.jpg",
            id: 23
          }
        ]
      },


      {
        id:16,
        nombre: "Casa PDR",
        autores: "Arqs. Juliana Deschamps - Fabio Estremera - Federico Garcia.",
        ubicacion:"Calle 443 esquina 25  City Bell, La Plata,Provincia de Buenos Aires, Argentina.",
        descripcion:"Despojarse de cualquier prejuicio estilístico es un ejercicio complejo; en esta obra logramos ponerlo en práctica ante la necesidad de ampliar una vivienda cuyo usuario se sentía a gusto en ella; se trabajó sobre unos requisitos de uso muy claros de su parte. En el acto de acercamiento a la preexistencia y al programa de necesidades buscamos sintetizar los espacios de luz y sombra en el interior, identificar, ordenar, y poner en valor la paleta de materiales a utilizar en sus decisiones más primarias: como llegar al suelo, como articular los componentes verticales en horizontal y como cubrirlo sin dejar de atender los pequeños espacios que la elección de esa paleta nos dejaba abierta para ser explorados. Al ser un espacio para la recreación introspectiva, se cierra hacia el sector de la vivienda abriéndose el extenso jardín que se amplía con los linderos.",
        programa: "Espacio anexo a vivienda a unifamiliar.",
        año: "2005-2006. Proyecto y Obra.",
        superficie: "Total: 64m2, Cubierta: 57m2.",
        asesores: "Arq. Nicolás Saraví: cálculo de estructuras.",
        colaboradores: "Dibujos: Martin Bravi.",
        constructora: "Juan Rojas.",
        fotografias:"DEarquitectura.",

        imagenes: [

          {
            nombre: "15-00-foto.jpg",
            id: 1
          },
          {
            nombre: "15-01-foto.jpg",
            id: 2
          },
          {
            nombre: "15-02-foto.jpg",
            id: 3
          },
          {
            nombre: "15-03-foto.jpg",
            id: 4
          },
          {
            nombre: "15-04-foto.jpg",
            id: 5
          },
          {
            nombre: "15-05-foto.jpg",
            id: 6
          },
          {
            nombre: "15-06-foto.jpg",
            id: 7
          },
          {
            nombre: "15-07-foto.jpg",
            id: 8
          },
          {
            nombre: "15-plano-00-foto.jpg",
            id: 9
          },
          {
            nombre: "15-plano-01A-foto.jpg",
            id: 10
          },
          {
            nombre: "15-plano-01B-foto.jpg",
            id: 11
          },
          {
            nombre: "15-plano-02-foto.jpg",
            id: 12
          },
          {
            nombre: "15-plano-03-foto.jpg",
            id: 13
          },
          {
            nombre: "15-plano-06-foto.jpg",
            id: 14
          },
          {
            nombre: "15-plano-05-foto.jpg",
            id: 15
          },
          {
            nombre: "15-plano-04-foto.jpg",
            id: 16
          },
          {
            nombre: "15-plano-07-foto.jpg",
            id: 17
          },
          {
            nombre: "15-plano-08-foto.jpg",
            id: 18
          },
        ]
      },


      {
        id:17,
        nombre: "Parque Cerro La Movediza",
        autores: "Arqs. Juliana Deschamps - Fabio Estremera - Federico García – Nicolás Saraví.",
        ubicacion:"Tandil, Buenos Aires, Argentina.",
        descripcion:"Se interviene sólo en lugares donde ya hay huellas físicas: talladuras y grafittis en los bochones, una escalera, cavas generadas por la actividad extractiva, senderos para la producción, y la piedra; caída y rota. La piedra no será reconstruida, es más elocuente así, partida en pedazos. Habla de la fragilidad de un equilibrio natural roto, acelerado por la acción del hombre. El hombre reaparece donde ya estuvo. Se minimiza la intervención en el cerro, valorando su superficie, y se trabaja con objetos simplemente apoyados, suspendidos, sin fundaciones, produciendo contactos transparentes. El museo es el cerro mismo, su atractivo es cultural. Las canteras y la actividad extractiva son parte de la historia de Tandil, del destino final de la Movediza, y ahora de su museo. El recorrido se organiza vinculando las dos canteras revalorizando los senderos de los canteristas y picapedreros. El nuevo acceso propuesto es la esquina L. M. Campos y M. Galfré; un pavimento de gravilla, donde se agrupan las actividades de mayor impacto. En la primera cantera, grupos de vegetación autóctona (chilcas, colas de zorro, cortaderas, etc.) acompañan los senderos y organizan los sectores para estacionamiento. En la segunda cantera, en el cruce de los cuatro senderos, se posa una piedra artificial en equilibrio. No es un edificio; es un lugar. El Eco Museo es un “nuevo equilibrio”, una colaboración entre el objeto posado con su vacío abstracto, y la piedra de la cava con sus marcas. Está simplemente apoyado sobre tres puntos, en bloques irregulares de la cantera. El “nuevo objeto” se recorre en todas sus caras, incluyendo la cubierta de piedra partida, un espacio de interpretación. Una piedra artificial en equilibrio; un equilibrio entre el habitar humano y la naturaleza.",
        programa: "Acceso, estacionamientos, ecomuseo, servicios y áreas gastronómicas, puntos panorámicos, senderos.",
        año: "2005.",
        superficie: "3 ha. Total, construida: 1600 m2.",
        asesores: "Ing. Aldo Parma, cálculo de estructuras.",
        promotor: "Municipalidad de Tandil.",
        

        imagenes: [

          {
            nombre: "17-00-foto.jpg",
            id: 1
          },
          {
            nombre: "17-01-foto.jpg",
            id: 2
          },
          {
            nombre: "17-02-foto.jpg",
            id: 3
          },
          {
            nombre: "17-03-foto.jpg",
            id: 4
          },
          {
            nombre: "17-04-foto.jpg",
            id: 5
          },
          {
            nombre: "17-05-foto.jpg",
            id: 6
          },
          {
            nombre: "17-06-foto.jpg",
            id: 7
          },
          {
            nombre: "17-07-foto.jpg",
            id: 8
          },
          {
            nombre: "17-08-foto.jpg",
            id: 9
          },
         
          
        ]
      },



      {
        id:18,
        nombre: "3 Casas",
        autores: "Arqs. Juliana Deschamps- Fabio Estremera – Federico García – Nicolás Saravi.",
        ubicacion: "Calle 30 e/ 491 y 493 Gonnet, La Plata, Provincia de Buenos Aires, Argentina.",
        descripcion: "El proyecto busca construir un tejido para vivir en contacto con el espacio verde y asegurar la inmediatez del espacio exterior. La subdivisión del terreno se proyectó de modo de encontrar la espacialidad de la vivienda. Se propusieron terrenos de ancho variable, un recurso de alteración mínima que permite tener la percepción de un espacio mayor en cada parcela. Así, varían las situaciones sumando visuales transversales largas. El espacio del terreno, y con ello el de las casas, varía perceptualmente complementándose con el de sus vecinos sin perder privacidad, diluyendo los límites del espacio propio mediante el uso de cercos vivos que, por encima de la altura de una persona, se funden en un solo parque. Cada vivienda ocupa un ancho de 14,3 m. Para ello se escalonan, tomando las dos dimensiones del terreno. Se gana así, la identidad de cada vivienda evitando tanto el anonimato de la repetición como la distorsión escalar del bloque único, asumiendo el carácter suburbano del contexto. Se disponen una serie de planos blancos paralelos que funcionan en distintas capas del proyecto. La vivienda se desarrolla entre planos, cada actividad encuentra su lugar y escala. Un espacio único sectorizado, reúne las actividades sociales; rodeado de verde, sus límites se disuelven abarcando el semicubierto de acceso, sumando las transparencias y desvaneciendo su presencia en el parque. Dominan las tensiones espaciales que generan visuales diagonales en espacios netamente cartesianos.",
        programa: "Tres viviendas unifamiliares agrupadas para cuatro habitantes cada una, piscina y áreas exteriores privadas.",
        año: "2004-2006. Proyecto y Obra.",
        superficie: "Terreno: 1400m2, Total construida: 345m2. Sup. Por vivienda: 115m2 + piscina 27m2.",
        asesores: "Arq. Nicolás Saraví: cálculo de estructuras.",
        colaboradores: "Dibujos: Martin Bravi. Maqueta: DEarquitectura",
        constructora: "Juan Rojas",
        fotografias:"DEarquitectura + Elisa Deschamps + Nicolás Saraví.",

        imagenes: [
          {
            nombre: "16-00-foto.jpg",
            id: 1
          },
          {
            nombre: "16-01-foto.jpg",
            id: 2
          },
          {
            nombre: "16-02-foto.jpg",
            id: 3
          },
          {
            nombre: "16-03-foto.jpg",
            id: 4
          },
          {
            nombre: "16-04-foto.jpg",
            id: 5
          },
          {
            nombre: "16-05-foto.jpg",
            id: 6
          },
          {
            nombre: "16-06-foto.jpg",
            id: 7
          },
          {
            nombre: "16-plano-00-foto.jpg",
            id: 8
          },
          {
            nombre: "16-plano-01-foto.jpg",
            id: 9
          },
          {
            nombre: "16-plano-02-foto.jpg",
            id: 10
          },
          {
            nombre: "16-plano-03-foto.jpg",
            id: 11
          },
          {
            nombre: "16-plano-04-foto.jpg",
            id: 12
          },
          {
            nombre: "16-plano-05-foto.jpg",
            id: 13
          },     
          {
            nombre: "16-plano-06-foto.jpg",
            id: 14
          }
        ]
      },


      

      {
        id:19,
        nombre: "Casa sobre el arroyo CHD",
        autores: "Arqs. Juliana Deschamps - Fabio Estremera.",
        ubicacion:"Arroyo Doña Flora, camino a club Regatas La Plata, entrada Nº 18 s/n, Ensenada, Provincia de Buenos Aires, Argentina.",
        descripcion:"Se trataba de una reforma y cambio de programa en una construcción existente de dos plantas sobre un terreno inundable a orillas del arroyo Doña Flora, en el delta del Rio Santiago; dejaría de ser una casa de fin de semana para darle uso en forma permanente. Un espacio en planta baja inundable varias veces al año, sin ser intervenida, pasa a ser quincho para uso de familiares. Sobre la losa existente de hº aº en planta alta de 8x8 con dos escaleras (interior y exterior) apoyada sobre la medianera oeste, se proyectó la vivienda para una pareja transitando la etapa de la vida para el ocio. La panorámica de un paisaje singular,los lugares de guardado, y una tecnología rápida y liviana a fin de evitar altas cargas sobre la estructura existente constituyeron la paleta básica de diseño. El espacio es definido por el diseño estructural y viceversa: una viga antepecho metálica y espacial (que sirve como placard) resuelve la transición entre la estructura de hormigón existente y la cubierta liviana. La necesidad de colocar los puntos de apoyo al borde de la losa para maximizar superficie llevó a diluir los elementos portantes en una sucesión de perfiles t de 4 cm quitando peso visual, relacionando las dimensiones interiores con el paisaje. Tres filtros con el exterior regulan el interior: una tela mosquitero sujeta a los parantes de la estructura posibilita a la línea de carpinterías abrirse en épocas estivales y acondicionar pasivamente el interior; completa el sistema un plano de cortinas roller blackout para controlar el oscurecimiento.",
        programa: "Residencia permanente para dos personas.",
        año: "2000. Proyecto y Obra.",
        superficie: "Total: 64m2, Cubierta: 57m2.",
        asesores: "Ing. Aldo Parma, cálculo de estructuras.",
        colaboradores: "Dibujos: Martin Bravi, Franco Angeleri; Maqueta: Flavio Di Bin.",
        constructora: "Darío Gonzalez.",
        fotografias:"Hernan Vazquez / DEarquitectura.",

        imagenes: [

          {
            nombre: "00-00-foto.jpg",
            id: 1
          },
          {
            nombre: "00-01-foto.jpg",
            id: 2
          },
          {
            nombre: "00-02-foto.jpg",
            id: 3
          },
          {
            nombre: "00-03-foto.jpg",
            id: 4
          },
          {
            nombre: "00-04-foto.jpg",
            id: 5
          },
          {
            nombre: "00-05-foto.jpg",
            id: 6
          },
          {
            nombre: "00-06-foto.jpg",
            id: 7
          },
          {
            nombre: "00-07-foto.jpg",
            id: 8
          },
          {
            nombre: "00-08-foto.jpg",
            id: 9
          },
          {
            nombre: "00-09-foto.jpg",
            id: 10
          },
          {
            nombre: "00-10-foto.jpg",
            id: 11
          },
          {
            nombre: "00-11-foto.jpg",
            id: 12
          },
          {
            nombre: "00-12-foto.jpg",
            id: 13
          },
          {
            nombre: "00-plano-00-foto.jpg",
            id: 14
          },
          {
            nombre: "00-plano-01-foto.jpg",
            id: 15
          },
          {
            nombre: "00-plano-02-foto.jpg",
            id: 16
          },
          {
            nombre: "00-plano-03-foto.jpg",
            id: 17
          },
          {
            nombre: "00-plano-04-foto.jpg",
            id: 18
          },
         
          {
            nombre: "00-plano-05-foto.jpg",
            id: 19
          }
        ]
      },




      


      
    ],
  };
  /*IMP Siempre value es objeto, siempre el AppContext.Consume, recive una funcion, 
  y como parametro el value
  */
  render() {
    return (
      <AppContext.Provider value={this.state}> 
        {this.props.children}
      </AppContext.Provider>
    );
  }
}
